import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import AuthButton from "../AuthButton/AuthButton";
import Input from "../Input/Input";
import { Logout, LOGOUTLOADER, POPUP, refreshToken } from "../../Actions/actions";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { toast } from "react-toastify";
import moment from "moment";
import CustomToast from "../CustomToast/CustomToast";

const AssetReportModal = ({ isOpen, onClose, heading, need, edit, setEdit, setchange, change }) => {
  const dispatch = useDispatch();

  const { loginData, employeesData, singleAssets } = useSelector((state) => state.userReducer);

  const [allAssets, setAllAssets] = useState([]);
  const [loader, setLoader] = useState(false);
  // const [hide, sethide] = useState(false);

  const [errors, setErrors] = useState({
    assetId: "",
    assetType: "",
    task: "",
    startFrom: "",
    endTo: "",
    employeeId: "",
    status: "Assigned",
    mileage: 0,
  });

  const [formData, setFormData] = useState({
    assetId: "",
    assetType: "",
    task: "",
    startFrom: Date.now(),
    endTo: Date.now(),
    employeeId: "",
    status: "Assigned",
    mileage: 0,
  });

  useEffect(() => {
    let data = {
      assetId: singleAssets?.assetId ? singleAssets?.assetId : "",
      assetType: singleAssets?.assetType ? singleAssets?.assetType : "",
      task: singleAssets?.task ? singleAssets?.task : "",
      startFrom: singleAssets?.startFrom ? singleAssets?.startFrom : Date.now(),
      endTo: singleAssets?.endTo ? singleAssets?.endTo : Date.now(),
      employeeId: singleAssets?.employeeId ? singleAssets?.employeeId : "",
      status: singleAssets?.status ? singleAssets?.status : "Assigned",
      mileage: singleAssets?.Mileage ? singleAssets?.Mileage : 0,
    };
    setFormData({ ...data });
  }, [singleAssets]);
  const ReportOption = [
    { value: "Client", label: "Client" },
    { value: "Subscription", label: "Subscription" },
    { value: "Transaction", label: "Transaction" },
  ];

  const salesRepOptions = employeesData?.map((source) => ({
    value: source.id,
    label: source.FullName,
  }));

  const selectedSalesRep = salesRepOptions?.find((option) => option.value === formData.employeeId);

  const assetOptions = allAssets?.map((source) => ({
    value: source.assetId,
    label: source.assetId + " | " + source.assetType,
  }));

  const selectedValue = assetOptions?.find((option) => option.value === formData.assetId);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const newValue =
      name === "mileage" ? (value === "" ? "" : value.match(/^(\d+(\.\d{0,2})?)$/) ? value : formData.mileage) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleChanges = (selectedOption) => {
    console.log(selectedOption);

    setFormData((prevState) => ({
      ...prevState,
      assetType: selectedOption.label,
      assetId: selectedOption.value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      assetType: "",
    }));
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {
      assetType: "",
      task: "",
      startFrom: "",
      endTo: "",
    };

    if (!formData.assetType) {
      newErrors.assetType = "This field is required";
      valid = false;
    }
    if (need && !formData.task) {
      newErrors.task = "Task is required";
      valid = false;
    }
    if (!formData.startFrom) {
      newErrors.startFrom = "Start date is required";
      valid = false;
    }
    if (!formData.endTo) {
      newErrors.endTo = "End date is required";
      valid = false;
    }
    if (!formData.employeeId) {
      newErrors.employeeId = "Select it is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData, "form Data is here");
    if (!validateForm()) return;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");
      const parsedData = {
        ...formData,
        status: "Assigned",
        mileage: parseFloat(formData.mileage) || 0,
      };
      const raw = JSON.stringify(parsedData);
      console.log(raw, "raw");
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/assets`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success === true) {
            setchange(!change);
            setFormData({
              assetType: "",
              task: "",
              startFrom: "",
              endTo: "",
              assetId: "",
            });
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          setLoader(false);
          console.log("create assets: ", result);
          onClose();
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleEdit = (e) => {
    e.preventDefault();
    console.log(formData, "form Data is here");
    if (!validateForm()) return;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const parsedData = {
        ...formData,
        Mileage: parseFloat(formData.mileage) || 0,
      };
      const raw = JSON.stringify(parsedData);
      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/assets/${singleAssets?.id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success === true) {
            setchange(!change);
            setFormData({
              assetType: "",
              task: "",
              startFrom: "",
              endTo: "",
              assetId: "",
            });
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          setLoader(false);
          console.log("edit assets: ", result);
          onClose();
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAssets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const getAssets = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/asset-types?unassigned=true`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          dispatch({ type: LOGOUTLOADER, payload: true });
          console.log(result);
          setAllAssets(result?.assetTypes);
          dispatch({ type: LOGOUTLOADER, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOGOUTLOADER, payload: false });
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div className="bg-gray-900 opacity-50 fixed inset-0" onClick={onClose}></div>

      {/* Popup */}
      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[40%] relative z-10">
        <button className="absolute top-7 right-5 text-gray-500 hover:text-gray-700" onClick={onClose}>
          <AiOutlineClose size={20} />
        </button>
        {edit ? (
          <h2 className="text-xl font-semibold mb-2">
            {formData.assetType} - {formData.assetId}
          </h2>
        ) : (
          <h2 className="text-xl font-semibold mb-6">{heading}</h2>
        )}

        <form onSubmit={edit ? handleEdit : handleSubmit} className="">
          {need ? (
            <div className="flex flex-row w-full">
              {/* <div className="relative top-3 left-4 bg-white px-1 w-[150px] mt-[-25px]">
                <label className="text-sm font-medium text-gray-600">
                  Select Asset Type
                </label>
              </div> */}

              {/* <select
                name="assetType"
                value={formData.assetType}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg p-3 w-full"
              >
                <option value="">Select Asset Type</option>
                {allAssets.map((item) => (
                  <option value={item.assetId}>{item.assetType}</option>
                ))}
              </select> */}
              {!edit && (
                <div className="w-1/2 mr-4">
                  <DropDownCustom
                    selectedValue={selectedValue}
                    handleChanges={handleChanges}
                    options={assetOptions}
                    isSearchable={false}
                    label="Asset ID*"
                    placeholder={"Select Asset ID"}
                  />

                  {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
                </div>
              )}
              <div className={`${edit ? "w-full" : "w-1/2"}`}>
                <DropDownCustom
                  selectedValue={selectedSalesRep}
                  handleChanges={(option) => {
                    setFormData({ ...formData, employeeId: option.value });
                    setErrors({ ...errors, employeeId: "" });
                  }}
                  options={salesRepOptions}
                  isSearchable={false}
                  label="Assign to Sales Rep*"
                  placeholder="Select Sales Rep"
                />
                {errors.employeeId && <p className="text-red-500 text-sm">{errors.employeeId}</p>}
              </div>
            </div>
          ) : (
            <div className="-mt-5">
              <DropDownCustom
                selectedValue={ReportOption?.find((option) => option.value === formData.assetType)}
                handleChanges={(e) => {
                  setFormData({ ...formData, assetType: e.value });
                }}
                options={ReportOption}
                isSearchable={false}
                label="Report Type"
                placeholder={"Select Report Type"}
              />
              {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
            </div>
          )}
          {need ? (
            <div className="mt-6">
              <Input
                type="text"
                label={"Task*"}
                name={"task"}
                float={true}
                value={formData.task}
                onChange={handleChange}
                placeholder="Task"
              />
              {errors.task && <p className="text-red-500 text-sm">{errors.task}</p>}
            </div>
          ) : null}

          <div className="flex flex-col sm:flex-row gap-6 mt-6">
            <div className="w-full">
              <Input
                type="date"
                float={true}
                label={"From"}
                value={moment(formData.startFrom).format("YYYY-MM-DD")}
                onChange={handleChange}
                name="startFrom"
              />
              {errors.startFrom && <p className="text-red-500 text-sm">{errors.startFrom}</p>}
            </div>
            <div className="w-full">
              <Input
                type="date"
                name="endTo"
                label="To"
                float
                value={moment(formData.endTo).format("YYYY-MM-DD")}
                onChange={handleChange}
              />
              {errors.endTo && <p className="text-red-500 text-sm">{errors.endTo}</p>}
            </div>
          </div>
          {formData?.assetType.includes("Cars") ? (
            <div className="mt-6">
              <Input
                type="text"
                label={"Mileage"}
                name={"mileage"}
                float={true}
                value={formData.mileage}
                onChange={handleChange}
                placeholder="mileage"
              />
              {errors.task && <p className="text-red-500 text-sm">{errors.mileage}</p>}
            </div>
          ) : null}
          {/* <DropDownCustom
            selectedValue={selectedSalesRep}
            handleChanges={(option) => {
              setFormData({ ...formData, employeeId: option.value });
              setErrors({ ...errors, employeeId: '' });
            }}
            options={salesRepOptions}
            isSearchable={false}
            label="Assign to Sales Rep"
            placeholder="Select Sales Rep"
          />
          {errors.employeeId && (
            <p className="text-red-500 text-sm">{errors.employeeId}</p>
          )} */}
          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              onClick={onClose}
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
            />
            {loader ? (
              <Loader />
            ) : (
              <AuthButton
                width={"20%"}
                title={edit ? "Edit" : "Generate"}
                className="px-4 py-2 text-white rounded-md"
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssetReportModal;
